import { Observable, of } from 'rxjs';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';

export namespace QuantityOpenPlatformProvider {
  export const defaultValueForDCO = 10;
  export const defaultValue = 1;

  export class DefaultValue extends BaseAsyncValue<number> {
    getValue(): Observable<number> {
      const service: ExperiencesService = this.injector.get(ExperiencesService);
      return service.commandDcoEnabled() ? of(defaultValueForDCO) : of(defaultValue);
    }
  }
}
